<div class="padding-txt">
    <h2 mat-dialog-title class="font-algoSalioMal" *ngIf="title != ''">
        {{title}}
    </h2>
</div>
<mat-dialog-content class="contentModal">
    <div class="container-fluid">
        <div class="aling">
            <div class="table-sio w-100 ">
                <ng-container *ngIf="error">
                    <div class="row-sio">
                        <div class="padding-txt">
                            <label class="font-algoSalioMal">¡UPS!, ALGO SALIO MAL</label><br>
                        </div>
                    </div>
                </ng-container>
                <div class="row-sio">
                    <div class="cell-sio py-10x px-20x align-bottom text-center">
                        <h5 [innerHtml]="message"></h5>
                    </div>
                </div>
                <ng-container *ngIf="error">
                    <div class="row-sio w-100" *ngIf="error">
                        <div class="cell-sio w-100">
                            <div class="padding-txt">
                                <label class="font-marcameTxt">Nos puedes marcar</label><br>
                            </div>
                            <div class="padding-txt">
                                <label class="font-numero">55442 46837</label><br>
                            </div>
                            <div class="padding-txt" *ngIf="llamar">
                                <label class="font-marcameTxt"> o te podemos marcar</label>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="llamar">
                        <div class="row-sio w-100">
                            <div class="cell-sop w-100">
                                <mat-form-field class="aling">
                                    <input matInput id="btnTelefono" placeholder="Teléfono/Celular"
                                        TypeValidation="number" maxlength="10" [(ngModel)]="telefono" />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row-sio w-100">
                            <div class="cell-sop w-100">
                                <mat-dialog-actions>
                                    <button mat-flat-button class="m-auto" [color]="styleCocheSeguro?.colorBtn" id="btnMarcame" [disabled]="valida()"
                                        (click)="obtenerAyuda()">Márcame</button>
                                </mat-dialog-actions>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="default">
                    <div class="row-sio">
                        <div class="cell-sio py-10x px-20x align-bottom text-center">
                            <ng-container *ngIf="accion != ''">
                                <button mat-flat-button [color]="styleCocheSeguro?.colorBtn"
                                    [ngClass]="classAccion != '' ? classAccion : ''"
                                    (click)="modalRef.close(true)">{{accion}}</button>
                            </ng-container>
                            <ng-container *ngIf="cancel && cancel != ''">
                                <button mat-button class="ml-5x" (click)="modalRef.close(false)">{{cancel}}</button>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</mat-dialog-content>